import clsx from "clsx";

import * as styles from "./horizontalDivider.module.css";

import type { Distance } from "client/src/components/Spacing/Spacing";

type HorizontalDividerProps = {
  size?: Distance;
};

const classes: Record<Distance, string> = {
  1: "my-[1px]",
  2: "my-[2px]",
  4: "my-[4px]",
  8: "my-[8px]",
  12: "my-[12px]",
  16: "my-[16px]",
  20: "my-[20px]",
  24: "my-[24px]",
  32: "my-[32px]",
  40: "my-[40px]",
  48: "my-[48px]",
  56: "my-[56px]",
  64: "my-[64px]",
  128: "my-[128px]",
};

export const HorizontalDivider = ({ size = 24 }: HorizontalDividerProps) => (
  <hr className={clsx(classes[size], styles.hr)} />
);
